import {Component, OnInit} from '@angular/core';
import {Page} from '../../../shared/models/page.interface';
import {KFConfiguration} from '../../../kf-data-entry/models/kf-configuration.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MessageService} from '../../../shared/services/message.service';
import {ActivatedRoute, Router} from '@angular/router';
import {KfConfigurationAdminService} from '../../services/kf-configuration-admin.service';
import {ReportCycleSearch} from '../../../admin/models/report-cycle-search.interface';

@Component({
  selector: 'app-kf-configuration-admin',
  templateUrl: './kf-configuration-admin.component.html',
  styleUrls: ['./kf-configuration-admin.component.scss']
})
export class KfConfigurationAdminComponent implements OnInit {
  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  kfConfigurationPage!: Page<KFConfiguration>;

  private page: PageRequest = {page: 0, size: 100, sort: 'year', direction: 'desc'};
  private search: ReportCycleSearch = {};

  constructor(private kfConfigurationService: KfConfigurationAdminService,
              private messageService: MessageService,
              private router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }


  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.search = this.getFiltersFromQueryParams(params);
      this.kfConfigurationService.search(this.search, this.page).subscribe(
        data => this.kfConfigurationPage = data
      );
    });

    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadKfConfigurations(event: PageRequest): void {
    this.kfConfigurationService.search(this.search, event).subscribe(
      data => {
        this.kfConfigurationPage = data;
      }
    );

  }

  searchKfConfiguration(event: ReportCycleSearch): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: this.buildQueryParams(event)});
  }


  reopenConfiguration(event: string): void {
    this.kfConfigurationService.reopen(event).subscribe(() => {
      this.loadKfConfigurations(this.page);
      this.messageService.showMessage('The configuration has been successfully opened', 'success');
    });
  }

  printPdf(event: KFConfiguration): void {
    this.kfConfigurationService
      .printPdf(event.year, event.elementId, event.schemaKind)
      .subscribe(response => {
        const blob = new Blob([response.body], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }

  private buildQueryParams(search: ReportCycleSearch): any {
    const queryParams = {};

    if (search.startYear) {
      Object.assign(queryParams, {startYear: search.startYear});
    }
    if (search.endYear) {
      Object.assign(queryParams, {endYear: search.endYear});
    }
    if (search.entry && search.entry !== '') {
      Object.assign(queryParams, {entry: search.entry});
    }
    if (search.unuKeyName && search.unuKeyName !== '') {
      Object.assign(queryParams, {unuKeyName: search.unuKeyName});
    }
    if (search.kfCategoryName && search.kfCategoryName !== '') {
      Object.assign(queryParams, {kfCategoryName: search.kfCategoryName});
    }
    if (search.collectionStreamName && search.collectionStreamName !== '') {
      Object.assign(queryParams, {collectionStreamName: search.collectionStreamName});
    }
    if (search.launched !== undefined) {
      Object.assign(queryParams, {launched: search.launched});
    }
    if (search.startLaunched && search.startLaunched !== '') {
      Object.assign(queryParams, {startLaunched: search.startLaunched});
    }
    if (search.endLaunched && search.endLaunched !== '') {
      Object.assign(queryParams, {endLaunched: search.endLaunched});
    }
    if (search.open) {
      Object.assign(queryParams, {open: search.open});
    }
    if (search.schemaKind && search.schemaKind !== '') {
      Object.assign(queryParams, {schemaKind: search.schemaKind});
    }
    return queryParams;
  }

  private getFiltersFromQueryParams(params: ReportCycleSearch): ReportCycleSearch {
    const search = {} as ReportCycleSearch;

    if (params.startYear) {
      search.startYear = params.startYear;
    }
    if (params.endYear) {
      search.endYear = params.endYear;
    }
    if (params.entry && params.entry !== '') {
      search.entry = params.entry;
    }
    if (params.unuKeyName && params.unuKeyName !== '') {
      search.unuKeyName = params.unuKeyName;
    }
    if (params.kfCategoryName && params.kfCategoryName !== '') {
      search.kfCategoryName = params.kfCategoryName;
    }
    if (params.collectionStreamName && params.collectionStreamName !== '') {
      search.collectionStreamName = params.collectionStreamName;
    }
    if (params.launched !== undefined) {
      search.startYear = params.startYear;
    }
    if (params.startLaunched && params.startLaunched !== '') {
      search.startLaunched = params.startLaunched;
    }
    if (params.endLaunched && params.endLaunched !== '') {
      search.endLaunched = params.endLaunched;
    }
    if (params.open) {
      search.open = params.open;
    }
    if (params.schemaKind && params.schemaKind !== '') {
      search.schemaKind = params.schemaKind;
    }
    return search;
  }

}
